var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-code"},[_c('img',{attrs:{"src":_vm.imageCodeUrl,"alt":"点击切换验证码","title":"点击切换验证码"},on:{"click":_vm.changeImageCode}})])
}
var staticRenderFns = []

export { render, staticRenderFns }